module.exports = __webpack_public_path__ + "static/img/我的预定（已拒绝）详情.58f65bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/我的预定（已拒绝）详情.png
// module id = /Tex
// module chunks = 1